import React, { useState } from 'react';
import { Trophy, MapPin, Heart, Calendar } from 'lucide-react';
import MonthlyRanking from '../components/MonthlyRanking';
import CityMonthlyRanking from '../components/CityMonthlyRanking';
import SpeedDateMatches from '../components/SpeedDateMatches';

type MainTab = 'ranking_italia' | 'ranking_citta' | 'speed_date';

const TAB_CONFIG: { key: MainTab; label: string; shortLabel: string; icon: React.ElementType }[] = [
  { key: 'ranking_italia', label: 'Classifica Mensile Italia', shortLabel: 'Italia', icon: Trophy },
  { key: 'ranking_citta', label: 'Classifica Mensile Citta', shortLabel: 'Citta', icon: MapPin },
  { key: 'speed_date', label: 'Match per Speed Date', shortLabel: 'Speed Date', icon: Heart },
];

const Matching = () => {
  const [activeTab, setActiveTab] = useState<MainTab>('ranking_italia');
  const [speedDateStats, setSpeedDateStats] = useState({
    eventsCount: 0,
    matchesCount: 0,
    participantsCount: 0,
    totalPreferences: 0,
  });

  return (
    <div className="p-4 sm:p-8">
      <div className="bg-gradient-to-br from-rose-500 to-pink-600 rounded-2xl shadow-xl mb-8 overflow-hidden">
        <div className="p-6 sm:p-8">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
              <p className="text-white/80 text-xs sm:text-sm font-medium">Eventi Chiusi</p>
              <p className="text-2xl sm:text-3xl font-bold text-white mt-1">{speedDateStats.eventsCount}</p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
              <p className="text-white/80 text-xs sm:text-sm font-medium">Match Trovati</p>
              <p className="text-2xl sm:text-3xl font-bold text-white mt-1">{speedDateStats.matchesCount}</p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
              <p className="text-white/80 text-xs sm:text-sm font-medium">Partecipanti</p>
              <p className="text-2xl sm:text-3xl font-bold text-white mt-1">{speedDateStats.participantsCount}</p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
              <p className="text-white/80 text-xs sm:text-sm font-medium">Preferenze Totali</p>
              <p className="text-2xl sm:text-3xl font-bold text-white mt-1">{speedDateStats.totalPreferences}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 mb-8">
        <div className="flex">
          {TAB_CONFIG.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex-1 flex items-center justify-center gap-2 px-3 sm:px-6 py-4 text-sm font-medium transition-all border-b-2 ${
                  isActive
                    ? 'border-rose-500 text-rose-600 bg-rose-50/50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Icon className="h-4 w-4 flex-shrink-0" />
                <span className="hidden sm:inline">{tab.label}</span>
                <span className="sm:hidden text-xs">{tab.shortLabel}</span>
              </button>
            );
          })}
        </div>
      </div>

      {activeTab === 'ranking_italia' && <MonthlyRanking />}
      {activeTab === 'ranking_citta' && <CityMonthlyRanking />}
      {activeTab === 'speed_date' && <SpeedDateMatches onStatsChange={setSpeedDateStats} />}
    </div>
  );
};

export default Matching;
